export const currentTimeline = (state = null, action) => {
  switch (action.type) {
    case 'TIMELINE_UPDATED':
      return action.timeline;
    default: return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/cameraTimeline.js